export class ContactField {
  name: string;
  email: string;
  message: string;
  lang: string;

  toJSON(): any {
    return {
      name: this.name,
      email: this.email,
      message: this.message,
      lang: this.lang,
    };
  }
}
